import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { ContractTypeResponse } from '../models/ContractTypeResponse';
import { SelectItem } from '../models/SelectItem';

const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root',
})
export class ContractTypeService {
  apiRoot: string;
  types: SelectItem[] = [];

  constructor(private http: HttpClient) {
    this.apiRoot = environment.cmApiRoot.url;
  }


  public getContractTypeList(): Observable<ContractTypeResponse> {

    return this.http.get<ContractTypeResponse>(`${this.apiRoot}/api/ContractTypes`);
  }


}

